<template>
  <WsRead
    ref="WsRead"
    localeMode
    :label="label"
    :fields="fields"
    :editable="false"
    :itemEditable="false"
    :id="$route.params.id"
    :modelName="modelName"
    :itemDeletable="false"
    :multiUrl="$_getMultiUrl"
    :customBtns="_customBtns"
    :primary="pageSetting.primary"
    :titleKey="'last_version.name'"
    :secondary="pageSetting.secondary"
    :deletable="_isCntStageInProgress"
    :modelVersionName="modelVersionName"
    :customBreadcrumbsItems="_customBreadcrumbsItems"
    @input="$_getModelData($event)"
    @set-idtf-owner="$refs.idtfSettingPopup.open(modelData)"
    @go-to-related-template="$_onGoToRelatedTemplate(modelData)"
  >
    <WsUpdateDialog
      ref="idtfSettingPopup"
      customTitle
      label="鑑別人員設定"
      :fields="_idtfSettingFields"
      @update-submit="$_onSubmitIdtfSettingPopup"
    />
  </WsRead>
</template>

<script>
import model from '@/models/act_idtf_assignment';
import submodel from '@/models/article';
import S_idtf from '@/services/api/v1/idtf';

export default {
  data() {
    return {
      modelName: model.modelName,
      modelVersionName: model.versionModelName,
      label: model.label,
      fields: model.fields,
      modelData: null,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            hideOnNull: false,
            floors: [
              {
                fields: [
                  'locales',
                  'reference_link',
                  'attaches',
                ],
              },
            ],
          },
          {
            type: 'expandList',
            label: submodel.label,
            modelName: submodel.versionModelName,
            modeParent: true,
            modeVersions: true,
            modeParentVersions: true,
            fields: submodel.fields.last_version.fields,
            titleKey: 'no_text',
            fieldsRead: [
              'locales',
              'announce_at',
              'effect_at',
              'attaches',
              'effects',
            ],
            batchMode: false,
            searchMode: false,
            orderBy: 'no_number',
            orderWay: 'asc',
            hideOnNull: false,
            isVersionAPI: true,
            itemCreatable: false,
            itemVersionReadableUrl: (modelData) => `/article/${modelData.article.id}/version`,
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'sequence',
                  'areas',
                  'act_type',
                  'industry_categories',
                  'system_classes',
                  'system_subclasses',
                  'range_type',
                  'factories',
                  'exclusive_factories',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規內容格式更新作業狀態',
                fields: [
                  'act_cnt_status',
                  'act_cnt_updated_admin',
                  'act_cnt_updated_at',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規鑑別作業狀態',
                fields: [
                  'idtf_status',
                  'idtf_updated_admin',
                  'idtf_updated_at',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規發布資訊',
                fields: [
                  'last_version.released_admin',
                  'last_version.released_at',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別資訊',
                fields: [
                  'created_admin',
                  'created_at',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別人員設定',
                fields: [
                  'has_released_first',
                  'has_idtf',
                  'km_owners',
                  'km_backups',
                  'km_reviewers',
                  'idtf_owners',
                  'idtf_backups',
                  'idtf_reviewers',
                  'overall_owners',
                ],
              },
            ],
          },
        ],
      },
    }
  },
  computed: {
    _customBtns() {
      const btns = [
        {
          title: `查看相關連動公版`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-view-dashboard',
          emit: 'go-to-related-template',
        },
      ];
      if (!this.modelData) return btns;
      if ( this.modelData.act_idtf_assignment.status == 2 ) {
        const settingBtn = {
          title: `鑑別人員設定`,
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-pencil',
          emit: 'set-idtf-owner',
        };
        btns.unshift(settingBtn);
      }
      return btns;
    },
    _idtfSettingFields() {
      const {
        km_owners,
        km_backups,
        km_reviewers,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      } = this.fields;
      const baseFields = {
        km_owners,
        km_backups,
        km_reviewers,
      };
      if (!this.modelData || this.modelData.has_idtf !== 1) return baseFields;
      return {
        ...baseFields,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      };
    },
    _isCntStageInProgress() {
      if (!this.modelData) return false;
      const { act_idtf_assignment, act_cnt_status } = this.modelData;
      return act_idtf_assignment.status == 2 && act_cnt_status !== 3;
    },
    _customBreadcrumbsItems() {
      const query = {...this.$route.query};
      const queryString = Object.entries(query)
        .filter(([key, value]) => value !== null && value !== undefined && value !== '' && key !== 'act')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      return [
        {
          text: this.label,
          to: queryString ? `/${this.modelName}?${queryString}` : `/${this.modelName}`,
          disabled: false,
        },
        {
          text: this.modelData ? this.modelData.last_version.name : '',
          disabled: true,
        }
      ];
    }
  },
  methods: {
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_onGoToRelatedTemplate(modelData){
      this.$router.push(
        `/act/${modelData.act_version.act.id}/relatedtemplate/${modelData.act_version.id}`
      );
    },
    $_onGoToReview(){
      this.$router.push(
        `/act_idtf_assignment/${this.$route.params.id}/review`
      );
    },
    $_getMultiUrl(modelData){
      if (!modelData) return []
      return [
        `/act/${modelData.act_version.act.id}`,
        `/act_version/${modelData.act_version.id}`,
      ]
    },
    async $_onSubmitIdtfSettingPopup($event) {
      const ref = this.$refs.idtfSettingPopup;
      try {
        ref.startLoading();
        const idtfId = this.modelData.act_idtf_assignment.id;
        await S_idtf.update(idtfId, $event);
        ref.stopLoading();
        ref.close();
        await this.$refs.WsRead.$_fetchData();
      } catch (error) {
        ref.stopLoading();
        alert(error);
      }
    }
  },
};
</script>